import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { FolderSymlinkIcon } from '~components/icons/FolderSymlinkIcon';
import { SpinnerIcon } from '~components/icons/SpinnerIcon';
import useLabels from '~hooks/useLabels';
import { AssetId } from '~modules/media-library/model/Asset';
import { Button } from '~modules/media-library/view/Button';

type AddToMyfilesButtonProps = {
  assetId: AssetId;
  onAddToMyfiles?: (assetId: AssetId) => Promise<void> | void;
};

export function AddToMyfilesButton({ assetId, onAddToMyfiles }: AddToMyfilesButtonProps) {
  const { btnMediaLibraryActionAddToMyfiles } = useLabels(['btnMediaLibraryActionAddToMyfiles']);
  const [isProcessing, toggleProcessing] = useToggle(false);

  const handleClick = useCallback(async () => {
    toggleProcessing();
    await onAddToMyfiles?.(assetId);
    toggleProcessing();
  }, [assetId, onAddToMyfiles, toggleProcessing]);

  if (!onAddToMyfiles) {
    return null;
  }

  return (
    <Button title={btnMediaLibraryActionAddToMyfiles} variant="icon" onClick={handleClick} disabled={isProcessing}>
      {isProcessing ? <SpinnerIcon className="animate-spin w-4 h-4" /> : <FolderSymlinkIcon />}
    </Button>
  );
}
